import { Observable } from "../../utils/observable";
import type { LanguageTag } from "./translations";

export class I18NStore {
  public localeTag = new Observable<LanguageTag>("en_US");
}
